module.exports = __webpack_public_path__ + "img/cloudjet.df0b4f41.png";